import isEmail from 'validator/lib/isEmail';
import dialog from './dialog';
import notification from './notification';

const submit = (url, data) => new Promise((resolve, reject) => {
    const csrfInput = document.querySelector('#_csrf');
    if (csrfInput) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-Token': csrfInput.value,
            },
        });
    }
    const form = $.param(data);
    $
        .post(url, form)
        .done((data) => {
            notification.notify('Success', 'Email sent');
            resolve(data);
        })
        .fail((error) => {
            notification.notify('Error', 'There was a problem sending your email, please try again');
            console.log(error);
            reject(error);
        });
});

async function shareEmail(evt) {
    evt.preventDefault();

    dialog.showDialog({
        id: 'share-via-email',
        title: 'Share via Email',
        focusButtons: false,
        htmlBody: `
            <div class="container">
                <div id="share-input-error" class="alert alert-danger d-none">
                </div>
                <div class="mb-3 row pt-2">
                    <label for="aurion-share-email-dialog-input-name" class="col-xs-12 col-sm-2 col-form-label">Name<span class="ℹ️">:</span></label>
                    <div class="col-xs-12 col-sm-10">
                    <input class="form-control" id="aurion-share-email-dialog-input-name" name="name" autofocus="">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="aurion-share-email-dialog-input-email" class="col-xs-12 col-sm-2 col-form-label">Email<span class="ℹ️">:</span></label>
                    <div class="col-xs-12 col-sm-10">
                    <input id="aurion-share-email-dialog-input-email" name="email" class="form-control">
                    </div>
                </div>
            </div>`,
        customClasses: {
            htmlBody: ['mx-4', 'my-2'],
        },
        btnConfigs: [{
            text: 'Cancel',
        },
        {
            text: 'Share',
            colour: 'Primary',
            preClickValidation: [{
                fieldId: 'aurion-share-email-dialog-input-name',
                predicate: (element) => !!element.value,
                errorMsg: 'Please enter your name',
            },
            {
                fieldId: 'aurion-share-email-dialog-input-email',
                predicate: (element) => !!element.value,
                errorMsg: 'Please enter your email',
            },
            {
                fieldId: 'aurion-share-email-dialog-input-email',
                errorId: 'InvalidEmail',
                predicate: (element) => isEmail(element.value),
                errorMsg: 'Please enter a valid email address',
            }],
            onClickEvent: async () => {
                const endpoint = document.querySelector('aurion-share-email-dialog').getAttribute('endpoint')
                    || `${document.URL.replace(/\/$/, '')}/share`;
                const name = document.getElementById('aurion-share-email-dialog-input-name').value;
                const email = document.getElementById('aurion-share-email-dialog-input-email').value;

                await submit(endpoint, { name, email });
            },
        }],
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('share-via-email')?.addEventListener('click', shareEmail);
});
